<template>
  <div class="tabbed">
      <input type="radio" id="tab1" name="css-tabs" checked />
      <input type="radio" id="tab2" name="css-tabs" />

      <ul class="tabs">
          <li class="tab"><label for="tab1">{{'residenceAddress' | lang}} </label></li>
          <li class="tab"><label for="tab2">{{'shippingAddress' | lang}} </label></li>
      </ul>
      <div class="tab-content">
          <div style="width: calc( 90% );margin:auto; " class="anagrafica">
              <div>
                  <div class="floating-label">
                      <select v-model="address.Title" placeholder=" " type="text" :class="{ invalid: errors.Title }">
                          <option v-for="(t, tidx) in customerTypes" :value="t" :key="tidx">{{t.Label}}</option>
                      </select>
                      <label>{{ 'Title' | lang }}</label>
                  </div>
                  <div class="floating-label">
                      <input v-model="address.FirstName" placeholder=" " type="text" :class="{ invalid: errors.FirstName }" />
                      <label>{{ 'Name' | lang }}</label>
                  </div>
                  <div class="floating-label">
                      <input v-model="address.LastName" placeholder=" " type="text" :class="{ invalid: errors.LastName }" />
                      <label>{{ 'LastName' | lang }}</label>
                  </div>
                  <div class="floating-label">
                      <select v-model="address.TypeOfLane" placeholder=" " :class="{ invalid: errors.TypeOfLane }">
                          <option v-for="(t, tidx) in routeTypes" :value="t" :key="tidx">{{t.Label}}</option>
                      </select>
                      <label>{{ 'RouteType' | lang }}</label>
                  </div>
                  <div class="floating-label">
                      <input v-model="address.Lane" placeholder=" " type="text" :class="{ invalid: errors.Lane }" />
                      <label v-if="address.TypeOfLane">{{address.TypeOfLane.Label}}</label>
                      <!-- <label v-else>{{ 'Lane' | lang }}</label> -->
                  </div>
                  <div class="floating-label">
                      <input v-model="address.NumberOnStreet" placeholder=" " type="text" :class="{ invalid: errors.NumberOnStreet }" />
                      <label>{{ 'NumberOnStreet' | lang }}</label>
                  </div>
                  <div class="floating-label">
                      <input v-model="address.Town" placeholder=" " type="text" :class="{ invalid: errors.Town }" />
                      <label>{{ 'Town' | lang }}</label>
                  </div>
                  <div class="floating-label">
                      <input v-model="address.AreaCode" placeholder=" " type="text" :class="{ invalid: errors.AreaCode }" />
                      <label>{{ 'Province' | lang }}</label>
                  </div>
                  <div class="floating-label">
                      <select v-model="address.Country" placeholder="l " type="text" :class="{ invalid: errors.Country }">
                          <option v-for="(t, tidx) in countryCodes" :value="t" :key="tidx" :selected="address.Country && t.Id === address.Country">{{t.Label}}</option>
                      </select>
                      <label>{{ 'Country' | lang }}</label>
                  </div>
              </div>
   
          </div>
      </div>
      <div class="tab-content">
          <div class="check-box-div">
              <i class="fa fa-fw fa-check-square-o" @click="setUseMainAddressForShip(false)" v-if="useMainAddressForShip === true"></i>
              <i class="fa fa-fw fa-square-o" @click="setUseMainAddressForShip(true)" v-else></i>
              {{'useResidenceAddressForShip' | lang}}
          </div>
          <div style="width: calc( 90% );margin:auto;" class="anagrafica">
              <div :class="{ invisible: useMainAddressForShip==true }">
                  <div class="floating-label">
                      <select v-model="addressShip.Title" placeholder=" " type="text" :class="{ invalid: errors.Title }">
                          <option v-for="(t, tidx) in customerTypes" :value="t" :key="tidx">{{t.Label}}</option>
                      </select>
                      <label>{{ 'Title' | lang }}</label>
                  </div>
                  <div class="floating-label">
                      <input v-model="addressShip.FirstName" placeholder=" " type="text" :class="{ invalid: errors.FirstName }" />
                      <label>{{ 'Name' | lang }}</label>
                  </div>
                  <div class="floating-label">
                      <input v-model="addressShip.LastName" placeholder=" " type="text" :class="{ invalid: errors.LastName }" />
                      <label>{{ 'LastName' | lang }}</label>
                  </div>
                  <div class="floating-label">
                      <select v-model="addressShip.TypeOfLane" placeholder=" " :class="{ invalid: errors.TypeOfLane }">
                          <option v-for="(t, tidx) in routeTypes" :value="t" :key="tidx">{{t.Label}}</option>
                      </select>
                      <label>{{ 'RouteType' | lang }}</label>
                  </div>
                  <div class="floating-label">
                      <input v-model="addressShip.Lane" placeholder=" " type="text" :class="{ invalid: errors.Lane }" />
                      <label v-if="addressShip.TypeOfLane">{{addressShip.TypeOfLane.Label}}</label>
                      <!-- <label v-else>{{ 'Lane' | lang }}</label> -->
                  </div>
                  <div class="floating-label">
                      <input v-model="addressShip.NumberOnStreet" placeholder=" " type="text" :class="{ invalid: errors.NumberOnStreet }" />
                      <label>{{ 'NumberOnStreet' | lang }}</label>
                  </div>
                  <div class="floating-label">
                      <input v-model="addressShip.Town" placeholder=" " type="text" :class="{ invalid: errors.Town }" />
                      <label>{{ 'Town' | lang }}</label>
                  </div>
                  <div class="floating-label">
                      <input v-model="addressShip.AreaCode" placeholder=" " type="text" :class="{ invalid: errors.AreaCode }" />
                      <label>{{ 'Province' | lang }}</label>
                  </div>
                  <div class="floating-label">
                      <select v-model="addressShip.Country" placeholder="l " type="text" :class="{ invalid: errors.Country }">
                          <option v-for="(t, tidx) in countryCodes" :value="t" :key="tidx" :selected="addressShip.Country && t.Id === addressShip.Country">{{t.Label}}</option>
                      </select>
                      <label>{{ 'Country' | lang }}</label>
                  </div>
              </div>
           
          </div>
      </div>

 
      <div class="sticky-bottom flexrow" v-if="showButton()" style="margin-top: 1rem;">
                  <button class="red" @click="undo()">{{ 'Undo' | lang }}</button>
                  <button class="green" @click="save()" :disabled="canSave==false">{{ 'Save' | lang }}</button>
          </div>
  </div>
</template>


<script>
import routeControl from '@/mixins/routeControl'
import UserServices from '@/mixins/services/userServices'
// import TimedButton from '@/components/TimedButton'
// import moment from 'moment'

export default {
  name: 'Address',
  mixins: [ UserServices, routeControl ],
  // components: { TimedButton },
  props: ['idx'],
  data () {
    return {
      useMainAddressForShip:true,
      indexAddress:-1,
      indexShipAddress:-1,
      address:{},
      addressShip: {},
      routeTypes: [],
      customerTypes: [],
      countryCodes: []
    }
  },
  computed: {
    isNew () {
      return this.idx === 'new'
    },
  
    exists () {
      return !!(this.userProfile && this.userProfile.profilo && this.userProfile.profilo.AddressInfo && this.userProfile.profilo.AddressInfo.length > 0)
    },
    originalAddress () {
      var address={};
      if (this.exists)
      {
        for(var i=0; i<this.userProfile.profilo.AddressInfo.length;i++)
        {
          if(this.userProfile.profilo.AddressInfo[i].IsCustomerPrimaryAddress==true)
          {
            address=this.userProfile.profilo.AddressInfo[i];
            this.indexAddress=i;
            break;
          }
        }
      }
      return address;
    },
    originalShipAddress () {
      var address={};
      if (this.exists)
      {
        for(var i=0; i<this.userProfile.profilo.AddressInfo.length;i++)
        {
          if(this.userProfile.profilo.AddressInfo[i].IsCustomerPrimaryAddress==false)
          {
            address=this.userProfile.profilo.AddressInfo[i];
            this.indexShipAddress=i;
            break;
          }
        }
      }
      return address;
    },
    editing () {
      return JSON.stringify(this.address) !== JSON.stringify(this.originalAddress)
    },
    editingShip () {
      return JSON.stringify(this.addressShip) !== JSON.stringify(this.originalShipAddress) &&  !(this.isEmpty(this.originalShipAddress) && this.useMainAddressForShip==true);
    },
    errors () {
      let FirstName = !this.address.FirstName
      let LastName = !this.address.LastName
      let NumberOnStreet = !this.address.NumberOnStreet // || isNaN(this.address.NumberOnStreet)
      let Lane = !this.address.Lane
      let Title = !this.address.Title
      let TypeOfLane = !this.address.TypeOfLane
      let Town = !this.address.Town
      let AreaCode = !this.address.AreaCode
      let Country = !this.address.Country
      return { FirstName, LastName, NumberOnStreet, Lane, Title, Town, TypeOfLane, AreaCode, Country, any: FirstName || LastName || NumberOnStreet || Lane || Title || Town || AreaCode || Country }
    },

    errorsShip () {
      let FirstName = !this.addressShip.FirstName
      let LastName = !this.addressShip.LastName
      let NumberOnStreet = !this.addressShip.NumberOnStreet // || isNaN(this.address.NumberOnStreet)
      let Lane = !this.addressShip.Lane
      let Title = !this.addressShip.Title
      let TypeOfLane = !this.addressShip.TypeOfLane
      let Town = !this.addressShip.Town
      let AreaCode = !this.addressShip.AreaCode
      let Country = !this.addressShip.Country
      return { FirstName, LastName, NumberOnStreet, Lane, Title, Town, TypeOfLane, AreaCode, Country, any: FirstName || LastName || NumberOnStreet || Lane || Title || Town || AreaCode || Country }
    },
    canSave()
    {
      return !( (this.errorsShip.any && this.useMainAddressForShip==false ) || this.errors.any) 
    }, 
  },
  methods: {
    resetShipAddress()
    {
      this.addressShip= {
        Active:false,
        IsCustomerPrimaryAddress:false,
        Title: null,
        FirstName: null,
        LastName: null,
        NumberOnStreet: null,
        Lane: null,
        TypeOfLane: null,
        Town: null,
        Country: null,
        AreaCode: null,
        Number: 2
      };
    },

    resetAddress()
    {
      this.address= {
        Active:true,
        IsCustomerPrimaryAddress:true,
        Title: null,
        FirstName: null,
        LastName: null,
        NumberOnStreet: null,
        Lane: null,
        TypeOfLane: null,
        Town: null,
        Country: null,
        AreaCode: null,
        Number: 1
      }
    },
    showButton()
    {   
      return this.editingShip || this.editing;
    },
    isEmpty(obj)
    {
    for(var prop in obj) {
        if(obj.hasOwnProperty(prop))
            return false;
    }
    return JSON.stringify(obj) === JSON.stringify({});
    },
    setUseMainAddressForShip(use){
      this.useMainAddressForShip=use;
      this.addressShip.Active=!this.useMainAddressForShip;
    },
    copyCurrentAddress () {
      this.address = this.exists  && !this.isEmpty(this.originalAddress) ? JSON.parse(JSON.stringify(this.originalAddress)) : this.address
    },
    copyCurrentShipAddress () {
      this.addressShip = this.exists && this.userProfile.profilo.AddressInfo.length >1 ? JSON.parse(JSON.stringify(this.originalShipAddress)) : this.addressShip;
    },
    undo()
    {
      this.copyCurrentShipAddress();
      this.copyCurrentAddress();
      if(this.originalShipAddress.Active==true)
      {
        this.useMainAddressForShip=false;
      }
      else
      {
        this.useMainAddressForShip=true;
      }
      
    },
    addressIsChanged (addresses) {
      this.$set(this.userProfile.profilo, 'AddressInfo', JSON.parse(JSON.stringify(addresses)))
    }, 
    save()
    {
      var promise=[];
      if(this.editing)
      {
        promise.push(this._saveUserAddresses(this.address));
      }

      if(this.editingShip)
      {
       
        promise.push(this._saveUserAddresses(this.addressShip));
      }

      Promise.all(promise).then((values) => {

        if(this.editing)
        {
          if(this.indexAddress<0){
            this.userProfile.profilo.AddressInfo.push(this.address)
          } else {
            this.$set(this.userProfile.profilo.AddressInfo, this.indexAddress, this.address)
          }
        
        }
      
        if(this.editingShip)
        {
          if(!this.useMainAddressForShip)
          {
           
            if(this.indexShipAddress<0){
              this.userProfile.profilo.AddressInfo.push(this.addressShip)
            } else {
              this.$set(this.userProfile.profilo.AddressInfo, this.indexShipAddress, this.addressShip)
            }
          }else// allora lo devo rimuovere
          {
           
            if(this.indexShipAddress>=0){
              this.userProfile.profilo.AddressInfo.splice(this.indexShipAddress,1);
              this.resetShipAddress();
            }
          }
        
        }
        this.copyCurrentShipAddress();
        this.copyCurrentAddress();
          this.internalBus.$emit('notify:success', {
            text: this.dictValue('Saved'),
            key: this.notifierKey,
            timeout: 3000
          })

      }).catch(error => {
        console.error(error)
        this.internalBus.$emit('notify:error', {
            text: this.dictValue('errorOccured') + (error.status === 418 ? '[VAD]' : ''),
            key: this.notifierKey,
            timeout: 3000
          })
      });

    },

    
  },
  mounted () {
    this.resetShipAddress();
    this.resetAddress();
    this.copyCurrentAddress();
    this.copyCurrentShipAddress();
    this._getDataList('RouteType').then(data => {
      this.routeTypes = data
    })
    this._getDataList('CustomerType').then(data => {
      this.customerTypes = data
    })
    this._getDataList('CountryCode').then(data => {
      this.countryCodes = data
    })

   if(this.originalShipAddress.Active==true)
    {
      this.useMainAddressForShip=false;
    }
  },
  watch: {
    userProfile () {
      if (!this.profile) {
        this.copyCurrentAddress();
        this.copyCurrentShipAddress();
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/_vars.scss';

#app.mobile .anagrafica > * {
  grid-template-columns: repeat(1, 100%);
}

#app.desktop.small .anagrafica > * {
  grid-template-columns: repeat(2, 50%);
}

.anagrafica > * {
  display: grid;
  column-gap: .1rem;
  grid-template-columns: repeat(4, 25%);
  padding-top: .1rem;
}


.tabbed {
	overflow-x: hidden; /* so we could easily hide the radio inputs */
	height: 100%;
  overflow: hidden;
  display: inline-flex;
  flex-direction: column;
}

.tabbed [type="radio"] {
	/* hiding the inputs */
	display: none;
}

.tabs {
	display: flex;
	align-items: stretch;
	list-style: none;
	padding: 0;
	border-bottom: 1px solid #ccc;
}
.tab > label {
	display: block;
	margin-bottom: -1px;
	padding: 12px 15px;
	border: 1px solid #ccc;
	background: #eee;
	color: #666;
	font-size: 12px; 
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 1px;
	cursor: pointer;	
	transition: all 0.3s;
}
.tab:hover label {
	border-top-color: #333;
	color: #333;
}

.tab-content {
	display: none;
	color: #777;
  margin-top: 1rem;
  overflow: auto;
  flex: 1;
}

/* As we cannot replace the numbers with variables or calls to element properties, the number of this selector parts is our tab count limit */
.tabbed [type="radio"]:nth-of-type(1):checked ~ .tabs .tab:nth-of-type(1) label,
.tabbed [type="radio"]:nth-of-type(2):checked ~ .tabs .tab:nth-of-type(2) label,
.tabbed [type="radio"]:nth-of-type(3):checked ~ .tabs .tab:nth-of-type(3) label,
.tabbed [type="radio"]:nth-of-type(4):checked ~ .tabs .tab:nth-of-type(4) label,
.tabbed [type="radio"]:nth-of-type(5):checked ~ .tabs .tab:nth-of-type(5) label {
	border-bottom-color: var(--white);
	border-top-color: var(--primary);
	background-color: var(--white);
	color: #222;
}

.tabbed [type="radio"]:nth-of-type(1):checked ~ .tab-content:nth-of-type(1),
.tabbed [type="radio"]:nth-of-type(2):checked ~ .tab-content:nth-of-type(2),
.tabbed [type="radio"]:nth-of-type(3):checked ~ .tab-content:nth-of-type(3),
.tabbed [type="radio"]:nth-of-type(4):checked ~ .tab-content:nth-of-type(4) {
	display: block;
}

.invisible {
    visibility: hidden;
  }

.check-box-div
{
    margin: 0.9rem 0;
    position: relative;
}

</style>
